<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Absensi" @back="back">
            <a-card type="inner" size="small" :bordered="true">
                <a-row type="flex">
                    <a-col :span="24">
                        <a-descriptions bordered>
                            <a-descriptions-item label="Sesi">
                                {{ session.name }}
                            </a-descriptions-item>
                            <a-descriptions-item label="Waktu mulai">
                                <template v-if="session.session_time_start != null">
                                    {{ moment(session.session_time_start).format('DD-MM-YYYY HH:mm:ss') }}
                                </template>
                            </a-descriptions-item>
                            <a-descriptions-item label="Waktu berakhir">
                                <template v-if="session.session_time_end != null">
                                    {{ moment(session.session_time_end).format('DD-MM-YYYY HH:mm:ss') }}
                                </template>
                            </a-descriptions-item>
                            <a-descriptions-item label="Peserta">
                                {{ this.items.members.length }}
                            </a-descriptions-item>
                            <a-descriptions-item label="Pelatihan">
                                {{ this.items.title }}
                            </a-descriptions-item>
                            <a-descriptions-item label="Deskripsi">
                                {{ this.items.description }}
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-col>
                </a-row>
            </a-card>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-skeleton :loading="preload" active>
                <a-table
                    class="pcp-table"
                    :dataSource="items.members"
                    rowKey="id"
                    :pagination="false"
                    :loading="loading"
                    bordered>

                    <a-table-column key="name" title="Nama Peserta" className="align-center text-small text-left">
                        <template slot-scope="record">
                            {{ record.name }}
                        </template>
                    </a-table-column>

                    <a-table-column key="absensi" title="Status Kehadiran" className="align-center text-center">
                        <template slot-scope="text, record, index">
                            <a-switch
                            @change="(c, e) => onChangeSwitch(c, e, record, index)"
                            :defaultChecked="record.is_presence == null ? true : record.is_presence == 1 ? true : false">
                                <a-icon slot="checkedChildren" type="check" />
                                <a-icon slot="unCheckedChildren" type="close" />
                            </a-switch>
                        </template>
                    </a-table-column>

                    <a-table-column key="observasi" title="Observasi" className="align-center text-small text-left">
                        <template slot-scope="text, record, index">
                            <a-textarea
                                @change="(e) => onChangeTextArea(e, record, index)"
                                :value="record.observation"
                                placeholder="Observasi"
                                :rows="4"
                            />
                        </template>
                    </a-table-column>
                </a-table>
                <a-row  type="flex" justify="end" style="margin-top: 10px">
                    <a-col><a-button
                        type="primary"
                        html-type="submit"
                        :loading="processing"
                        :disabled="processing"
                        @click="handleSubmit"
                        >Save All</a-button
                    ></a-col>
                </a-row>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
export default {
    props: {
        session: {
            type: Object
        }
    },
    created() {
        this.getItems()
    },
    data() {
        return {
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            loading: false,
            index: 0,
            items: {
                members: []
            },
        };
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.classical.attendance.show', {
                    session: this.session.id
                }))
                .then(response => (this.items = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        handleSubmit(e) {
            e.preventDefault(e)

            this.processing = true
            let arrParamId = []
            let data = {
                attendant: []
            }

            this.items.members.forEach(item => {
                arrParamId.push({
                    attendant_id: item.id,
                    is_presence: item.is_presence == null ? true : item.is_presence,
                    observation: item.observation
                })
            })

            data.attendant = arrParamId

            this.$http.post(this.routeUri('api.classical.attendance.store', {session: this.session.id}), data)
                .then(response => this.handleSuccessResponse(response.data))
                .catch(error => this.handleResponseError(error.response.data))
                .finally(() => this.processing = false)
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            })
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    })
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                })
            }
        },
        onChangeSwitch(c, e, record, index){
            this.items.members[index].is_presence = c
        },
        onChangeTextArea(e, record, index){
            this.items.members[index].observation = e.target.value
        },
        back() {
            window.location.href = this.routeUri('admin.classical.class.observation')
        },
    },
}
</script>
